import compassUrl from '../assets/compass.svg';
import { View } from '../CommonTypes';

const compassToDegrees: Record<string, number> = {
  N: 180,
  NNE: 157.5,
  NE: 135,
  ENE: 112.5,
  E: 90,
  ESE: 67.5,
  SE: 45,
  SSE: 22.5,
  S: 0,
  SSW: 337.5,
  SW: 315,
  WSW: 292.5,
  W: 270,
  WNW: 247.5,
  NW: 225,
  NNW: 202.5,
};

export const SolarCompass = ({ compass }: { compass: View['compass'] }) => {
  return (
    <div
      className="compass z-1 pointer-events-none absolute left-9 top-9 h-[0px] w-[0px] md:left-9 md:top-9 md:h-[82px] md:w-[82px]"
      style={{
        transform: `translate(-50%, -50%) rotate(${compassToDegrees[compass]}deg)}`,
        opacity: 0.9,
      }}
    >
      <img src={compassUrl} alt="Compass" className="h-full w-full" />
    </div>
  );
};
